export const buildexAllowedDomain = [
	"gmail.com",
	"yahoo.com",
	"hotmail.com",
	"outlook.com",
	"singnet.com.sg"
];
